import { Languages, Locale } from '@frontend/common';
import { useLocale } from '@frontend/lang';
import { useEffect, useState } from 'react';

interface ViewProps {
    options: { value: Locale; displayName: string }[] | null;
    onClick: (value: { value: Locale; displayName: string }) => Promise<void>;
    currentLocale?: Locale;
}

const useLanguageSelect = (): ViewProps => {
    const { locale, changeLocale, availableLanguages } = useLocale();
    const [options, setOptions] = useState<{ value: Locale; displayName: string }[] | null>(availableLanguages ?? Languages);

    useEffect(() => {
        setOptions(availableLanguages ?? Languages);
    }, [availableLanguages]);

    const onClick = async (value: { value: Locale; displayName: string }) => {
        changeLocale(value.value);
    };

    return {
        options,
        onClick,
        currentLocale: locale
    };
};

export default useLanguageSelect;
